export default "__VITE_ASSET__2bdaccf8__"